<template>
  <div class="indexschool graybg">
    <div id="content">
      <div class="schooltite" v-if="showData.titleShow === 1">
        <div class="headline font24">
          <span>{{showData != null? showData.title:''}}</span>
          <span class="more font14" @click="toNextList(showData)" v-if="showData.moreShow === 1">更多<img style="height: 12px;margin-left: 2px;position: relative;top: 1px;" src="/static/images/more.png" alt=""></span>
        </div>
      </div>
      <div class="schoolbox clearfix">
        <div class="fl" style="float: right;">
          <div class="schcon schleft">
            <img :src="setimg(showData.infos[0].picPath,$configUrl.futureImgUrl)" alt="">
            <div class="intro">{{showData.infos[0].text1}}</div>
          </div>
        </div>
        <div class="fr sright" style="float: left;">
          <Row :gutter="20">
            <Col span="8" v-for="(item,index) in showData.infos.slice(1,7)" :key="index">
              <div class="schcon schright">
                <img :src="setimg(item.picPath,$configUrl.futureImgUrl)" alt="">
                <div class="intro">{{item.text1}}</div>
              </div>
            </Col>
          </Row>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'indexSchool',
    props:{
      showData:{
        type:Object,
        default:null
      }
    },
    data() {
      return {
        futureImgUrl:''
      }
    },
    computed:{
      setimg(){
        return (val,imgpath)=> {
          const value = imgpath + val
          return value
        }
      },
      setMoreUrl() {
        return (str)=>{
          let arr = [];
          arr = str.split('?')
          this.toNextListStr = arr[0]
          return this.toNextListStr
        }
      },
      setMoreUrlId() {
        return (str)=>{
          let arr = [];
          let arr1 = [];
          let str1 = '';
          let arr2 = [];
          let data = {}
          arr = str.split('?')
          this.toNextListStr = arr[0];
          str1 = arr[1];
          arr1 = str1.split('&')
          for(let i = 0; i < arr1.length; i++){
            arr2.push(arr1[i].split('='))

          }
          console.log('arr2',arr2)

          for(let i=0;i<arr2.length;i++){
            data[arr2[i][0]] = arr2[i][1]
          }
          return data.plate_id;
        }
      }
    },
    mounted() {

    },
    methods:{
      toNextList(obj){
        this.$router.push({ path: obj.moreUrl,query:{name:encodeURI(obj.title)}});
         this.$nextTick(()=>{
           $("body").scrollTop(0);
         })

       },
    }
  }
</script>

<style scoped="scoped">
  .indexschool {
    padding: 50px 0 20px;
  }
  #content {
    width: 1200px;
    margin-bottom: 40px;
  }
  .headline {
    text-align: left;
    line-height: 1.8;
    font-weight: 500;
    border-bottom: 2px solid #3583FF;
    position: relative;
  }
  .headline .more {
    color: #3583FF;
    float: right;
    position: relative;
    top: 10px;
    cursor: pointer;
  }
  .schoolbox {
    margin-top: 50px;
  }
  .schleft {
    width: 470px;
  }
  .sright {
    width: 706px;
  }
  .schcon {
    position: relative;
    overflow: hidden;
    border-radius: 14px;
    line-height: 1;
  }
  .schright {
    margin-bottom: 25px;
  }
  .schcon .intro {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 40px;
    line-height: 40px;
    color: #fff;
    background-color: rgba(0,0,0,.5);
    text-align: left;
    width: 100%;
    padding:0 15px;
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .schcon img {
    display: block;
    width: 100%;
    transition: all .5s;
  }
  .schcon:hover img {
    transform: scale(1.1);
  }
  @media screen and (min-width: 1800px) {
    #content {
      width: 1662px;
    }
    .schleft {
      width: 653px;
    }
    .sright {
      width: 980px;
    }
    .schcon .intro {
      height: 60px;
      line-height: 60px;
      font-size: 20px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/indexContent/indexSchool.vue